import { getFirstAndLastDayYear } from "@/services/Utils";

export const baseMonth = [
	{
		id: 1,
		name: "Enero",
	},
	{
		id: 2,
		name: "Febrero",
	},
	{
		id: 3,
		name: "Marzo",
	},
	{
		id: 4,
		name: "Abril",
	},
	{
		id: 5,
		name: "Mayo",
	},
	{
		id: 6,
		name: "Junio",
	},
	{
		id: 7,
		name: "Julio",
	},
	{
		id: 8,
		name: "Agosto",
	},
	{
		id: 9,
		name: "Septiembre",
	},
	{
		id: 10,
		name: "Octubre",
	},
	{
		id: 11,
		name: "Noviembre",
	},
	{
		id: 12,
		name: "Diciembre",
	},
];

export const months = {
	1: "Enero",
	2: "Febrero",
	3: "Marzo",
	4: "Abril",
	5: "Mayo",
	6: "Junio",
	7: "Julio",
	8: "Agosto",
	9: "Septiembre",
	10: "Octubre",
	11: "Noviembre",
	12: "Diciembre",
};

export const weekDays = ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"];

export const monthsFormat = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

export const baseValueFilter = {
	business_id: "",
	aptitudes_id: "",
	season_id: "",
	initial_date: getFirstAndLastDayYear().first,
	final_date: getFirstAndLastDayYear().last,
};

export const baseFilter = {
	business_id: {
		description: "Razón Social",
		value: "",
		label: "",
		removable: true,
	},
	aptitudes_id: {
		description: "Aptitud",
		value: "",
		label: "",
		removable: true,
	},
	season_id: {
		description: "Temporada",
		value: "",
		label: "",
		removable: true,
	},
	initial_date: {
		description: "Desde",
		value: getFirstAndLastDayYear().first,
		label: getFirstAndLastDayYear().first,
		removable: true,
		is_date: true,
	},
	final_date: {
		description: "Hasta",
		value: getFirstAndLastDayYear().last,
		label: getFirstAndLastDayYear().last,
		removable: true,
		is_date: true,
	},
};

export const options = [
	{
		id: 1,
		name: "Valorización",
		relation: "valorization",
	},
	{
		id: 2,
		name: "Vencimiento",
		relation: "expiration",
	},
	{
		id: 3,
		name: "Compras vs aplicaciones",
		admin: true,
		relation: "sales",
	},
	{
		id: 4,
		name: "Productos fuera de bodega",
		relation: "out",
	},
	{
		id: 5,
		name: "Últimas aplicaciones",
		relation: "last",
	},
];
